import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const AddIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path clipRule="evenodd" d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill={color} fillRule="evenodd" />
      </svg>
    );
  },
);

export default AddIcon;
